import { i18n as r } from "@lingui/core";
import { LoginUiType as s, getLoginDisplayInfo as f, getValueWithPlaceholder as p } from "client-core";
import h from "date-fns/locale/de";
import g from "date-fns/locale/en-US";
import o from "bowser";
import { VaultType as a, VaultMemberSyncMode as w, debugConsole as l, WebauthnPrfSupportStatus as d } from "backend-client-web";
import { toArrayBufferBacked as m } from "vault-crypto";
const F = "0 0 0.5rem hsl(0deg 0% 0% / 50%)";
function R(e, t) {
  const n = f(e, t);
  return {
    ...n,
    headline: n.headline ?? b(p(e?.uiType))
  };
}
function b(e) {
  switch (e) {
    case s.creditCard:
      return r._(
        /** i18n */
        {
          id: "3dKLN3"
        }
      );
    case s.wifi:
      return r._(
        /** i18n */
        {
          id: "S6A_-d"
        }
      );
    case s.note:
      return r._(
        /** i18n */
        {
          id: "tF8MKq"
        }
      );
    case s.elsterCertificate:
      return r._(
        /** i18n */
        {
          id: "xkM21M"
        }
      );
    case s.login:
    case void 0:
      return r._(
        /** i18n */
        {
          id: "4QFgr2"
        }
      );
  }
}
function k(e) {
  switch (e) {
    case s.creditCard:
      return r._(
        /** i18n */
        {
          id: "ooW934"
        }
      );
    case s.wifi:
      return r._(
        /** i18n */
        {
          id: "UutMhs"
        }
      );
    case s.note:
      return r._(
        /** i18n */
        {
          id: "tF8MKq"
        }
      );
    case s.elsterCertificate:
      return r._(
        /** i18n */
        {
          id: "xkM21M"
        }
      );
    case s.login:
    case void 0:
      return r._(
        /** i18n */
        {
          id: "z0t9bb"
        }
      );
  }
}
function P() {
  return r.locale === "de" ? h : g;
}
const y = 3, T = 1e3;
class B {
  index = 0;
  touchTimeout;
  onDebugTriggered;
  debugString;
  touchTrigger;
  constructor({
    onDebugTriggered: t,
    debugString: n = "DEBUG",
    touchTrigger: i = !1
  }) {
    this.onDebugTriggered = t, this.debugString = n, this.touchTrigger = i;
  }
  init() {
    window.addEventListener("keypress", this.onKeypress), this.touchTrigger && (window.addEventListener("touchstart", this.onTouchstart), window.addEventListener("touchend", this.onTouchend));
  }
  close() {
    window.removeEventListener("keypress", this.onKeypress), this.touchTrigger && (window.removeEventListener("touchend", this.onTouchend), window.removeEventListener("touchstart", this.onTouchstart));
  }
  onKeypress = (t) => {
    t.defaultPrevented || (t.key === this.debugString[this.index] ? (this.index += 1, this.index === this.debugString.length && (this.onDebugTriggered(), this.index = 0)) : this.index = 0);
  };
  onTouchstart = (t) => {
    this.updateTouchTriggerTimeout(t);
  };
  onTouchend = (t) => {
    this.updateTouchTriggerTimeout(t);
  };
  updateTouchTriggerTimeout(t) {
    if (t.touches.length !== y) {
      window.clearTimeout(this.touchTimeout), this.touchTimeout = void 0;
      return;
    }
    this.touchTimeout || (this.touchTimeout = window.setTimeout(() => {
      this.touchTimeout = void 0, this.onDebugTriggered();
    }, T));
  }
}
function A() {
  return navigator.credentials;
}
function K(e) {
  if (!window.PublicKeyCredential || A()?.get === void 0)
    return !1;
  const t = e ?? o.parse(window.navigator.userAgent), n = t.os.name === "Linux" && t.browser.name === "Firefox";
  return n && t.browser.version ? Number.parseFloat(t.browser.version) >= 114 : !n;
}
function V(e) {
  const t = e ?? o.parse(window.navigator.userAgent);
  return t.os.name === "Android" ? !1 : t.browser.name === "Chrome" || t.browser.name === "Microsoft Edge" || t.browser.name === "Opera" ? !0 : t.browser.name === "Firefox" && t.browser.version ? Number.parseFloat(t.browser.version) >= 118 : !1;
}
function W(e) {
  const t = e ?? o.parse(window.navigator.userAgent);
  return t.os.name === "iOS" || t.os.name === "macOS";
}
function G(e) {
  const t = e ?? o.parse(window.navigator.userAgent);
  return t.os.name === "Chrome OS" ? !0 : t.platform.type === "desktop" && !_(e);
}
function _(e) {
  const t = e ?? o.parse(window.navigator.userAgent);
  return t.platform.type === "desktop" && t.browser.name === "Safari" && // iPad Safari likes to pretend it is macOS Safari by cloning its user agent:
  // https://github.com/lancedikson/bowser/issues/455 But it doesn't support our extension, so we
  // need to exclude it here based on somewhat sketchy fingerprinting. Yeah, I don't like it
  // either.
  window.navigator?.maxTouchPoints === 5;
}
function j(e) {
  const t = e ?? o.parse(window.navigator.userAgent);
  return t.browser.name === "Firefox" && t.browser.version ? Number.parseFloat(t.browser.version) >= 149 : !1;
}
function H(e, t) {
  return v(e).map((n) => x(n, t));
}
function v(e) {
  const t = [];
  let n = e;
  for (; n; ) {
    const i = n.at(0);
    if (i && !i.match(/[\x00-\x7f]/) && !i.match(/\s/)) {
      t.push(i), n = n.substring(1);
      continue;
    }
    const c = n.search(/\+/);
    if (c === -1) {
      t.push(n);
      break;
    }
    t.push(n.substring(0, c).trim().toLowerCase()), n = n.substring(c + 1).trim();
  }
  return t;
}
function x(e, t) {
  if (t)
    switch (e) {
      case "macctrl":
        return "⌃";
      // Firefox uses "Ctrl" for the command key according to spec when set from manifest.json. When
      // the shortcut is changed from ui "Command" is used for the command key instead.
      case "ctrl":
      case "command":
        return "⌘";
      case "shift":
        return "⇧";
      case "alt":
        return "⌥";
      case "enter":
        return "↵";
      case "esc":
        return "⎋";
      case "home":
        return "↖";
      case "end":
        return "↘";
      case "pageup":
        return "⇞";
      case "pagedown":
        return "⇟";
    }
  switch (e) {
    case "ctrl":
    case "strg":
      return r._(
        /** i18n */
        {
          id: "F5QOVM"
        }
      );
    case "shift":
    case "umschalttaste":
      return r._(
        /** i18n */
        {
          id: "PGetcZ"
        }
      );
    case "alt":
      return r._(
        /** i18n */
        {
          id: "mac4Aw"
        }
      );
    case "enter":
      return r._(
        /** i18n */
        {
          id: "9Vnjc9"
        }
      );
    case "esc":
      return r._(
        /** i18n */
        {
          id: "zO1gmR"
        }
      );
    case "home":
      return r._(
        /** i18n */
        {
          id: "i0qMbr"
        }
      );
    case "end":
      return r._(
        /** i18n */
        {
          id: "xDr_ct"
        }
      );
    case "pageup":
      return r._(
        /** i18n */
        {
          id: "ycPJXO"
        }
      );
    case "pagedown":
      return r._(
        /** i18n */
        {
          id: "lojVac"
        }
      );
    case "comma":
      return ",";
    case "period":
    case "punkt":
      return ".";
    case "space":
      return r._(
        /** i18n */
        {
          id: "pOE8Vh"
        }
      );
    case "insert":
      return r._(
        /** i18n */
        {
          id: "mSlBXj"
        }
      );
    case "delete":
      return r._(
        /** i18n */
        {
          id: "W_50sr"
        }
      );
    case "up":
    case "up arrow":
      return "↑";
    case "down":
    case "down arrow":
      return "↓";
    case "left":
    case "left arrow":
      return "←";
    case "right":
    case "right arrow":
      return "→";
    case "medianexttrack":
      return "⏭";
    case "mediaplaypause":
      return "⏯";
    case "mediaprevtrack":
      return "⏮";
    case "mediastop":
      return "⏹";
    default:
      return L(e);
  }
}
function L(e) {
  return `${e[0].toUpperCase()}${e.slice(1).toLowerCase()}`;
}
function E(e) {
  if (e.type === a.TEAM && e.memberSyncMode === w.ALL_DELEGATED_ADMINS)
    return r._(
      /** i18n */
      {
        id: "JRcOXm"
      }
    );
  if (e.name)
    return e.name;
  switch (e.type) {
    case a.PRIVATE:
      return r._(
        /** i18n */
        {
          id: "12Aozu"
        }
      );
    case a.ORGANIZATION_PERSONAL:
      return r._(
        /** i18n */
        {
          id: "oENbfc"
        }
      );
    case a.TEAM:
      return r._(
        /** i18n */
        {
          id: "57_aFB"
        }
      );
    case a.INBOX:
      return r._(
        /** i18n */
        {
          id: "lh348v"
        }
      );
  }
}
function J(e, t) {
  const n = E(e);
  return `${t?.name ?? r._(
    /** i18n */
    {
      id: "Ysej7j"
    }
  )} – ${n}`;
}
function S(e) {
  return Object.entries(e).filter(([, t]) => t).map(([t]) => t);
}
function $(e) {
  return S(e).length > 1 ? "multiple" : e.securityKey ? "securityKey" : e.mobileSafari ? "mobileSafari" : "phone";
}
function X(e) {
  if (l.info("webauthn.create credential", e), !e)
    throw new Error("Unexpectedly received no credential");
  if (!(e instanceof PublicKeyCredential))
    throw new Error(`Unexpected credential type ${e?.type}`);
  if (!(e.response instanceof AuthenticatorAttestationResponse))
    throw new Error("Unexpected AssertionResponse type");
  const {
    prf: t
  } = e.getClientExtensionResults();
  return {
    id: e.id,
    rawId: new Uint8Array(e.rawId),
    response: {
      attestationObject: new Uint8Array(e.response.attestationObject),
      clientDataJSON: new Uint8Array(e.response.clientDataJSON),
      transports: e.response.getTransports ? e.response.getTransports() : void 0
    },
    prfSupportStatus: t ? t.enabled ? d.AVAILABLE : d.UNAVAILABLE : d.UNKNOWN,
    // NOTE: Hardware support not available at the time of writing (2023-09-25), but it's available
    // by browser spec, so we include it here for completeness.
    prfExtensionResult: t?.results ? {
      first: u(t.results.first),
      second: t.results.second ? u(t.results.second) : void 0
    } : void 0
  };
}
function z(e) {
  if (l.info("webauthn.get credential", e), !e)
    throw new Error("Unexpectedly received no credential");
  if (!(e instanceof PublicKeyCredential))
    throw new Error(`Unexpected credential type ${e?.type}`);
  if (!(e.response instanceof AuthenticatorAssertionResponse))
    throw new Error("Unexpected AssertionResponse type");
  const {
    prf: t
  } = e.getClientExtensionResults();
  return {
    id: e.id,
    rawId: new Uint8Array(e.rawId),
    response: {
      authenticatorData: new Uint8Array(e.response.authenticatorData),
      clientDataJSON: new Uint8Array(e.response.clientDataJSON),
      signature: new Uint8Array(e.response.signature),
      userHandle: e.response.userHandle ? new Uint8Array(e.response.userHandle) : void 0
    },
    prfExtensionResult: t?.results ? {
      first: u(t.results.first),
      second: t.results.second ? u(t.results.second) : void 0
    } : void 0
  };
}
function u(e) {
  return e instanceof ArrayBuffer ? new Uint8Array(e) : m(new Uint8Array(e.buffer, e.byteOffset, e.byteLength));
}
export {
  B as D,
  F as L,
  S as a,
  z as b,
  b as c,
  J as d,
  X as e,
  R as f,
  P as g,
  E as h,
  A as i,
  k as j,
  H as k,
  W as l,
  j as m,
  _ as n,
  K as o,
  V as p,
  G as s,
  u as t,
  $ as u
};
//# sourceMappingURL=webauthn-DV2ZpN1b.js.map
